import {
    ADD_TO_CART,
    REMOVE_CART_ITEM,
    SAVE_SHIPPING_INFO,
    EMPTY_CART,
  } from "../constants/cartConstant.js";
  
  const sameLine = (a, b) => a.product === b.product && (a.size || "") === (b.size || "");

export const cartReducer = (State = { cartItems: [], shippingInfo: {} }, action) => {
    switch (action.type) {
      case ADD_TO_CART:
        const item = action.payload;
  
        // A cart line is a product in one size, so the same product in another size is its own line
        const isItemExist = State.cartItems.find((i) => sameLine(i, item));
  
        if (isItemExist) {
          return {
            ...State,
            cartItems: State.cartItems.map((i) => (sameLine(i, item) ? item : i)),
          };
        } else {
          return {
            ...State,
            cartItems: [...State.cartItems, item],
          };
        }
      case EMPTY_CART:
        return {
          ...State,
          cartItems: [],
        };
      case REMOVE_CART_ITEM:
        return {
          ...State,
          // payload is { product, size } for one line (a plain id removes every size of that product)
          cartItems: State.cartItems.filter((i) =>
            typeof action.payload === "object" && action.payload !== null
              ? !sameLine(i, action.payload)
              : i.product !== action.payload
          ),
        };
  
      case SAVE_SHIPPING_INFO:
        return {
          ...State,
          shippingInfo: action.payload,
        };
  
      default:
        return State;
    }
  };